import {
  createRouter,
  createWebHistory,
} from 'vue-router';
import { h, resolveComponent } from 'vue';
import publicRoutes from "@/router/public_routes";
import NotFound from '@/public/views/errorPages/NotFound.vue';
import Unauthorized from '@/public/views/errorPages/AccessDenied.vue';
import Login from '@/public/views/UserLogin.vue';
import { getRoleByToken, getToken } from "@/kernel/utils"; 
import privateRoutes from "@/router/private_routes";

const routes = [
  {
    path: '',
    redirect: '/home',
  },
  {
    path: '/',
    component: {
      render() {
        return h(resolveComponent("router-view"));
      }
    },
    children: [
      ...publicRoutes.map(route => {
        route.meta.requireAuth = false;
        return { ...route };
      }),
      ...privateRoutes.map(route => {
        route.meta.requireAuth = true;
        return { ...route };
      }),
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFound
  },
  {
    name: "unautorized",
    path: "/unautorized",
    component: Unauthorized
  },
  {
    path: '/admin',
    name: 'admin',
    component: Login,
    meta: {
      title: 'Inicio de sesión'
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }; // Añadido scroll al inicio
  },
});

router.beforeEach(async (to, from, next) => {
  const publicRoutes = [
    "/admin", "/unautorized", "/home", "/about", 
    "not-found", "/history", "/esg", "/operations", 
    "/location", "/gallery"
  ];
  const authRequired = !publicRoutes.includes(to.path);
  const loggedIn = getToken();

  if (authRequired && !loggedIn) {
    return next("/admin");
  }

  if (loggedIn) {
    const role = await getRoleByToken();
    const roleUpper = role?.toUpperCase();

    // Redirección exclusiva para INVESTORS
    if (roleUpper === "INVESTORS") {
      const allowedPath = ["/news-investors", "/list-files-investors"];
      if (!allowedPath.includes(to.path)) {
        return next("/list-files-investors");
      }
    }

    // Validación por rol
    if (to.meta?.role) {
      const allowedRoles = Array.isArray(to.meta.role)
        ? to.meta.role.map(r => r.toUpperCase())
        : [to.meta.role.toUpperCase()];

      if (!allowedRoles.includes(roleUpper)) {
        return next("/unautorized");
      }
    }

    return next();
  }

  next();
});

export default router;
